/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Impressum_Dispute_TextInputs */

const en_impressum_dispute_text = /** @type {(inputs: Impressum_Dispute_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In accordance with Section 36 VSBG (Consumer Dispute Resolution Act), we inform you: We are neither willing nor obligated to participate in dispute resolution proceedings before a consumer arbitration board.`)
};

const de_impressum_dispute_text = /** @type {(inputs: Impressum_Dispute_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gemaess SS 36 VSBG (Verbraucherstreitbeilegungsgesetz) informieren wir Sie: Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.`)
};

const fr_impressum_dispute_text = /** @type {(inputs: Impressum_Dispute_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La Commission européenne met à disposition une plateforme de règlement en ligne des litiges (RLL) :`)
};

const es_impressum_dispute_text = /** @type {(inputs: Impressum_Dispute_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La Comisión Europea proporciona una plataforma para la resolución de disputas en línea (ODR):`)
};

const it_impressum_dispute_text = /** @type {(inputs: Impressum_Dispute_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La Commissione Europea mette a disposizione una piattaforma per la risoluzione delle controversie online (ODR):`)
};

const nl_impressum_dispute_text = /** @type {(inputs: Impressum_Dispute_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De Europese Commissie biedt een platform voor onlinegeschillenbeslechting (ODR):`)
};

const pl_impressum_dispute_text = /** @type {(inputs: Impressum_Dispute_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Komisja Europejska udostępnia platformę do rozstrzygania sporów online (ODR):`)
};

const fi_impressum_dispute_text = /** @type {(inputs: Impressum_Dispute_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Euroopan komissio tarjoaa alustan verkkovälitteiseen riitojenratkaisuun (ODR):`)
};

const da_impressum_dispute_text = /** @type {(inputs: Impressum_Dispute_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Europa-Kommissionen stiller en platform til rådighed for onlinetvistbilæggelse (ODR):`)
};

const sv_impressum_dispute_text = /** @type {(inputs: Impressum_Dispute_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Europeiska kommissionen tillhandahåller en plattform för tvistlösning online (ODR):`)
};

/**
* | output |
* | --- |
* | "In accordance with Section 36 VSBG (Consumer Dispute Resolution Act), we inform you: We are neither willing nor obligated to participate in dispute resolutio..." |
*
* @param {Impressum_Dispute_TextInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const impressum_dispute_text = /** @type {((inputs?: Impressum_Dispute_TextInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Impressum_Dispute_TextInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_impressum_dispute_text(inputs)
	if (locale === "fr") return fr_impressum_dispute_text(inputs)
	if (locale === "es") return es_impressum_dispute_text(inputs)
	if (locale === "it") return it_impressum_dispute_text(inputs)
	if (locale === "nl") return nl_impressum_dispute_text(inputs)
	if (locale === "pl") return pl_impressum_dispute_text(inputs)
	if (locale === "fi") return fi_impressum_dispute_text(inputs)
	if (locale === "da") return da_impressum_dispute_text(inputs)
	if (locale === "sv") return sv_impressum_dispute_text(inputs)
	return en_impressum_dispute_text(inputs)
});